// Static browser-tab titles per page. Dynamic pages (order/project/profile
// details) build their own title from fetched data and fall back to these.
const PAGE_TITLES = {
  dashboard: 'Dashboard',
  createOrder: 'Create Order',
  orderDetails: 'Order Details',
  allOrders: 'All Orders',
  allProjects: 'All Projects',
  newProject: 'New Project',
  projectDetails: 'Project Details',
  newProfile: 'New Profile',
  profile: 'Profile',
  allProfiles: 'All Profiles',
  siteMap: 'Site Map',
  bulkOrderCheck: 'Bulk Order Check',
  rateCalculator: 'Rate Calculator',
  jurisdictionCredentials: 'Jurisdiction Credentials',
  documentTypeManagement: 'Document Type Management',
  documentTypeVisibility: 'Document Type Visibility',
  documentTypeMapping: 'Document Type Mapping',
  productNameManagement: 'Client-Facing Product Names',
  emailSignature: 'Email Signature',
  mailer: 'Mailer',
  composeEmail: 'Compose Email',
  teams: 'Teams',
  people: 'People',
  notFound: 'Page Not Found',
  login: 'Login',
  resetPassword: 'Reset Password',
  setPassword: 'Set Password',
  sessionExpired: 'Session Expired',
  onboarding: 'Onboarding'
};

export default PAGE_TITLES;
